<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="8"
      >
        <v-card>
          <v-card-title>
            <v-btn
              icon
              class="mr-2"
              @click="$router.go(-1)"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <span class="text-h5">Гостевой пропуск</span>
          </v-card-title>
          <v-card-text v-if="item">
            <v-row>
              <v-col
                cols="12"
                md="7"
              >
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr>
                        <td>Public ID</td>
                        <td>{{ item.public_id }}</td>
                      </tr>
                      <tr>
                        <td>Код</td>
                        <td class="text-h6">
                          {{ item.code }}
                        </td>
                      </tr>
                      <tr v-if="item.place_name">
                        <td>Место</td>
                        <td>{{ item.place_name }}</td>
                      </tr>
                      <tr>
                        <td>Состояние</td>
                        <td>
                          <v-chip
                            small
                            :color="item.state_color"
                            dark
                          >
                            {{ item.state_text }}
                          </v-chip>
                        </td>
                      </tr>
                      <tr>
                        <td>Посетитель</td>
                        <td>
                          <span v-if="item.name_erased_at">удалено (retention)</span>
                          <span v-else>{{ item.visitor_name }}</span>
                        </td>
                      </tr>
                      <tr v-if="item.purpose">
                        <td>Цель визита</td>
                        <td>{{ item.purpose }}</td>
                      </tr>
                      <tr v-if="item.host_subject_ref">
                        <td>Принимающий субъект</td>
                        <td>{{ item.host_subject_ref }}</td>
                      </tr>
                      <tr>
                        <td>Действует с</td>
                        <td>{{ item.valid_from }}</td>
                      </tr>
                      <tr>
                        <td>Действует по</td>
                        <td>{{ item.valid_to }}</td>
                      </tr>
                      <tr>
                        <td>Проходов всего</td>
                        <td>{{ item.uses_total }}</td>
                      </tr>
                      <tr>
                        <td>Проходов осталось</td>
                        <td>{{ item.uses_left }}</td>
                      </tr>
                      <tr v-if="item.revoked_at">
                        <td>Отозван</td>
                        <td>{{ item.revoked_at }}</td>
                      </tr>
                      <tr>
                        <td>Создан</td>
                        <td>{{ item.created_at }}</td>
                      </tr>
                      <tr v-if="item.created_by">
                        <td>Кем создан</td>
                        <td>{{ item.created_by }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col
                v-if="item.qr_png_url"
                cols="12"
                md="5"
                class="text-center"
              >
                <img
                  :src="item.qr_png_url"
                  style="max-width: 240px"
                  alt="QR гостевого пропуска"
                >
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-else>
            <v-skeleton-loader type="article" />
          </v-card-text>
          <v-card-actions v-if="item">
            <v-btn
              v-if="item.state === 0"
              color="red"
              outlined
              @click="revoke_dialog.show = true"
            >
              Отозвать
            </v-btn>
            <v-spacer />
            <v-btn
              color="secondary darken-1"
              outlined
              @click="$router.go(-1)"
            >
              Назад
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="revoke_dialog.show"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Отозвать гостевой пропуск</span>
        </v-card-title>
        <v-card-text>
          <div class="mb-3">
            Пропуск {{ item ? item.code : '' }} будет отозван.
          </div>
          <v-text-field
            v-model="revoke_dialog.reason"
            label="Причина (необязательно)"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            :loading="revoke_dialog.loading"
            @click="revoke()"
          >
            <span class="mx-4">Отозвать</span>
          </v-btn>
          <v-btn
            color="secondary darken-1"
            outlined
            rounded
            small
            class="ml-2 mb-2"
            @click="revoke_dialog.show = false"
          >
            <span class="mx-4">Отмена</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Страница просмотра гостевого пропуска (id и place из query). Отзыв с необязательной причиной.
import { SkudGuestService } from '@/views/skud/shared/services/skud-guest-service'

export default {
  name: 'SkudGuestView',
  data: () => ({
    svc: null,
    item: null,
    loading: false,
    revoke_dialog: { show: false, reason: '', loading: false }
  }),
  computed: {
    place () {
      return this.$route.query.place
    }
  },
  mounted () {
    this.svc = new SkudGuestService()
    this.load()
  },
  methods: {
    async load () {
      if (!this.place || !this.$route.query.id) {
        this.item = null
        return
      }
      this.loading = true
      this.item = await this.svc.getGuest(this.place, this.$route.query.id)
      this.loading = false
      if (!this.item) {
        this.$store.commit('snackbar', 'Пропуск не найден')
      }
    },
    async revoke () {
      this.revoke_dialog.loading = true
      const body = { public_id: this.item.public_id }
      if (this.revoke_dialog.reason) body.reason = this.revoke_dialog.reason
      const r = await this.svc.revokeGuest(this.place, body)
      this.revoke_dialog.loading = false
      this.revoke_dialog.show = false
      if (r.ok) {
        this.$store.commit('snackbar', 'Гостевой пропуск отозван')
        this.load()
      } else {
        this.$store.commit('snackbar', r.error || 'Ошибка при отзыве')
      }
    }
  }
}
</script>
